module.exports = __webpack_public_path__ + "static/img/小雨转中雨.29f9e881.svg";